export const FLYOUT_HEIGHT = 270
export const BUTTON_CLASSNAME = 'logo-button'
